import { APILLC, LLCDocument, LLCProductRequest } from '../types/llc';
import axios from './axios';

export function getLLC(companyId: number) {
  return axios.get<APILLC[]>(`/companies/${companyId}/products/llc/company_llc/`).then(({ data }) => data);
}

export function setSignableDocumentInProcess(companyId: number, llcId: number, documentId: number) {
  return axios
    .post<LLCDocument>(
      `/companies/${companyId}/products/llc/company_llc/${llcId}/documents/${documentId}/set_in_process/`
    )
    .then(({ data }) => data);
}

export function createLLCProductRequest(companyId: number) {
  return axios
    .post<LLCProductRequest>(`/companies/${companyId}/products/llc/company_llc/request/`)
    .then(({ data }) => data);
}

export function getLLCProductRequest(companyId: number) {
  return axios
    .get<LLCProductRequest[]>(`/companies/${companyId}/products/llc/company_llc/request/`)
    .then(({ data }) => data);
}
